module.exports = __webpack_public_path__ + "static/media/laundry.63062a4a.svg";